export default __webpack_public_path__ + "static/media/logo_maxi.d0b1e89a.png";